import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleFooter from '../components/simpleFooter';
import { withRouter } from 'react-router-dom';

const ThankYou = ({ history }) => {

    const { t } = useTranslation();

    useEffect(() => {

        //return to main page
        setTimeout(() => {
            history.push({
                pathname: '/'
               });
        },3000)
        
    })

    return (
        <div className="full-page ">
            <div className="thanks-bg">
                <div className="container">
                    <div className="col-md-12">
                        <div className="thanks-section">
                            <div>
                                <img src="assets/images/thank-you.png" className="img-fluid downlod-img" alt="" />
                                <div className="col-lg-8 offset-lg-2">
                                    <h2>{t('thank you')}</h2>
                                </div>
                                <h3>{t('let\'s keep in touch')}!</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/*copy-right-section*/}
            <SimpleFooter />
            {/*end copy right section*/}
        </div>
    );
}

export default withRouter(ThankYou);


// WEBPACK FOOTER //
// ./src/pages/thank-you.js